import {
    REMOVE_CONNECTION_START,
    REMOVE_CONNECTION_SUCCESS,
    REMOVE_CONNECTION_FAIL,
    MUTE_CONNECTION_START,
    MUTE_CONNECTION_SUCCESS,
    MUTE_CONNECTION_FAIL,
    UNMUTE_CONNECTION_START,
    UNMUTE_CONNECTION_SUCCESS,
    UNMUTE_CONNECTION_FAIL,
    FETCH_MUTED_CONNECTION_LIST_START,
    FETCH_MUTED_CONNECTION_LIST_SUCCESS,
    FETCH_MUTED_CONNECTION_LIST_FAIL,
    FETCH_CONNECTION_COUNT_SUCCESS,
    FETCH_CONNECTION_COUNT_FAIL,
    RESET_NEWS_FEED_CONNECTIONS,
    FETCH_SUGGESTED_CONNECTION_LIST_START,
    FETCH_SUGGESTED_CONNECTION_LIST_SUCCESS,
    FETCH_SUGGESTED_CONNECTION_LIST_FAIL,
    FETCH_PAGED_SUGGESTED_CONNECTION_LIST_START,
    FETCH_PAGED_SUGGESTED_CONNECTION_LIST_SUCCESS,
    FETCH_PAGED_SUGGESTED_CONNECTION_LIST_FAIL,
    UPDATE_PAGED_SUGGESTED_CONNECTION_DISMISSING,
    REMOVE_PAGED_SUGGESTED_CONNECTION,
    CLEAR_PAGED_SUGGESTED_CONNECTION_LIST,
    FETCH_SUGGESTED_CONNECTIONS_COUNT_SUCCESS,
    FETCH_SUGGESTED_CONNECTIONS_COUNT_FAIL
} from 'actions/ActionTypes';

const INITIAL_STATE = {
    connectionRemoving: false,
    connectionRemoveSuccess: false,
    connectionRemoveFail: false,
    connectionMuting: false,
    connectionMuteSuccess: false,
    connectionMuteFail: false,
    connectionUnmuting: false,
    connectionUnmuteSuccess: false,
    connectionUnmuteFail: false,
    mutedConnectionList: [],
    mutedConnectionListFetching: false,
    mutedConnectionListFetchSuccess: false,
    mutedConnectionListFetchFail: false,
    connectionCount: null,
    connectionCountSuccess: false,
    connectionCountFail: false,
    suggestedConnectionList: [],
    suggestedConnectionListFetching: false,
    suggestedConnectionListFetchSuccess: false,
    suggestedConnectionListFetchFail: false,
    pagedSuggestedConnectionList: { profileList: [], hasMore: false, nextCursor: null },
    pagedSuggestedConnectionListFetching: false,
    pagedSuggestedConnectionListFetchSuccess: false,
    pagedSuggestedConnectionListFetchFail: false,
    suggestedConnectionsCount: -1,
    suggestedConnectionsCountFetchSuccess: false,
    suggestedConnectionsCountFetchFail: false
};

const connectionRemoving = (state) => ({
    ...state,
    connectionRemoving: true,
    connectionRemoveSuccess: false,
    connectionRemoveFail: false
});

const connectionMuting = (state) => ({
    ...state,
    connectionMuting: true,
    connectionMuteSuccess: false,
    connectionMuteFail: false
});

const connectionUnmuting = (state) => ({
    ...state,
    connectionUnmuting: true,
    connectionUnmuteSuccess: false,
    connectionUnmuteFail: false
});

const connectionRemoveFinished = (isSuccess) => (state) => ({
    ...state,
    connectionRemoving: false,
    connectionRemoveSuccess: isSuccess,
    connectionRemoveFail: !isSuccess
});

const connectionMuteFinished = (isSuccess) => (state) => ({
    ...state,
    connectionMuting: false,
    connectionMuteSuccess: isSuccess,
    connectionMuteFail: !isSuccess
});

const connectionUnmuteFinished = (isSuccess) => (state) => ({
    ...state,
    connectionUnmuting: false,
    connectionUnmuteSuccess: isSuccess,
    connectionUnmuteFail: !isSuccess
});

const mutedConnectionListFetching = (state) => ({
    ...state,
    mutedConnectionListFetching: true,
    mutedConnectionListFetchSuccess: false,
    mutedConnectionListFetchFail: false
});

const fetchMutedConnectionListFinished = (isSuccess) => (state, { mutedConnectionList }) => ({
    ...state,
    mutedConnectionList,
    mutedConnectionListFetching: false,
    mutedConnectionListFetchSuccess: isSuccess,
    mutedConnectionListFetchFail: !isSuccess
});

const connectionCountGetFinished = (isSuccess) => (state, { connectionCount }) => ({
    ...state,
    connectionCount,
    connectionCountSuccess: isSuccess,
    connectionCountFail: !isSuccess
});

const resetNewsfeedConnections = () => {
    return INITIAL_STATE;
};

const suggestedConnectionListFetching = (state) => ({
    ...state,
    suggestedConnectionListFetching: true,
    suggestedConnectionListFetchSuccess: false,
    suggestedConnectionListFetchFail: false
});

const suggestedConnectionListFetchFinished = (isSuccess) => (state, { data }) => {
    return {
        ...state,
        suggestedConnectionList: data.profileList,
        suggestedConnectionListFetching: false,
        suggestedConnectionListFetchSuccess: isSuccess,
        suggestedConnectionListFetchFail: !isSuccess
    };
};

const pagedSuggestedConnectionListFetching = (state) => ({
    ...state,
    pagedSuggestedConnectionListFetching: true,
    pagedSuggestedConnectionListFetchSuccess: false,
    pagedSuggestedConnectionListFetchFail: false
});

const pagedSuggestedConnectionListFetchFinished = (isSuccess) => (state, { data }) => {
    const { profileList, hasMore, nextCursor, connectionSuggestionRequest, suggestionStatus } = data;
    // initialFetch: true  => replace the original list
    // initialFetch: false => append to the original list
    const initialFetch = connectionSuggestionRequest.cursor === null;

    // add isDismissing attribute
    let updatedProfileList = profileList.map((profile) => ({ ...profile, isDismissing: false }));
    return {
        ...state,
        pagedSuggestedConnectionList: {
            profileList: initialFetch
                ? updatedProfileList
                : state.pagedSuggestedConnectionList.profileList.concat(updatedProfileList),
            hasMore,
            nextCursor,
            suggestionStatus
        },
        pagedSuggestedConnectionListFetching: false,
        pagedSuggestedConnectionListFetchSuccess: isSuccess,
        pagedSuggestedConnectionListFetchFail: !isSuccess
    };
};

const updatePagedSuggestedConnectionDismissing = (state, action) => {
    const { displayName, dismissing } = action.payload;
    return {
        ...state,
        pagedSuggestedConnectionList: {
            ...state.pagedSuggestedConnectionList,
            profileList: state.pagedSuggestedConnectionList.profileList.map((profile) => {
                if (profile.displayName === displayName) {
                    return {
                        ...profile,
                        isDismissing: dismissing
                    };
                }
                return profile;
            })
        }
    };
};

const removePagedSuggestedConnection = (state, action) => {
    const { displayName } = action.payload;
    return {
        ...state,
        pagedSuggestedConnectionList: {
            ...state.pagedSuggestedConnectionList,
            profileList: state.pagedSuggestedConnectionList.profileList.filter(
                (profile) => profile.displayName !== displayName
            )
        }
    };
};

const clearPagedSuggestedConnectionList = (state) => ({
    ...state,
    pagedSuggestedConnectionList: {
        profileList: [],
        hasMore: false,
        nextCursor: null
    },
    pagedSuggestedConnectionListFetching: false,
    pagedSuggestedConnectionListFetchSuccess: false,
    pagedSuggestedConnectionListFetchFail: false
});

const fetchSuggestedConnectionsCountFinished = (isSuccess) => (state, { count }) => ({
    ...state,
    suggestedConnectionsCount: isSuccess ? count : -1,
    suggestedConnectionsCountFetchSuccess: isSuccess,
    suggestedConnectionsCountFetchFail: !isSuccess
});

const handlers = {
    [REMOVE_CONNECTION_START]: connectionRemoving,
    [REMOVE_CONNECTION_SUCCESS]: connectionRemoveFinished(true),
    [REMOVE_CONNECTION_FAIL]: connectionRemoveFinished(false),
    [MUTE_CONNECTION_START]: connectionMuting,
    [MUTE_CONNECTION_SUCCESS]: connectionMuteFinished(true),
    [MUTE_CONNECTION_FAIL]: connectionMuteFinished(false),
    [UNMUTE_CONNECTION_START]: connectionUnmuting,
    [UNMUTE_CONNECTION_SUCCESS]: connectionUnmuteFinished(true),
    [UNMUTE_CONNECTION_FAIL]: connectionUnmuteFinished(false),
    [FETCH_MUTED_CONNECTION_LIST_START]: mutedConnectionListFetching,
    [FETCH_MUTED_CONNECTION_LIST_SUCCESS]: fetchMutedConnectionListFinished(true),
    [FETCH_MUTED_CONNECTION_LIST_FAIL]: fetchMutedConnectionListFinished(false),
    [FETCH_CONNECTION_COUNT_SUCCESS]: connectionCountGetFinished(true),
    [FETCH_CONNECTION_COUNT_FAIL]: connectionCountGetFinished(false),
    [RESET_NEWS_FEED_CONNECTIONS]: resetNewsfeedConnections,
    [FETCH_SUGGESTED_CONNECTION_LIST_START]: suggestedConnectionListFetching,
    [FETCH_SUGGESTED_CONNECTION_LIST_SUCCESS]: suggestedConnectionListFetchFinished(true),
    [FETCH_SUGGESTED_CONNECTION_LIST_FAIL]: suggestedConnectionListFetchFinished(false),
    [FETCH_PAGED_SUGGESTED_CONNECTION_LIST_START]: pagedSuggestedConnectionListFetching,
    [FETCH_PAGED_SUGGESTED_CONNECTION_LIST_SUCCESS]: pagedSuggestedConnectionListFetchFinished(true),
    [FETCH_PAGED_SUGGESTED_CONNECTION_LIST_FAIL]: pagedSuggestedConnectionListFetchFinished(false),
    [UPDATE_PAGED_SUGGESTED_CONNECTION_DISMISSING]: updatePagedSuggestedConnectionDismissing,
    [REMOVE_PAGED_SUGGESTED_CONNECTION]: removePagedSuggestedConnection,
    [CLEAR_PAGED_SUGGESTED_CONNECTION_LIST]: clearPagedSuggestedConnectionList,
    [FETCH_SUGGESTED_CONNECTIONS_COUNT_SUCCESS]: fetchSuggestedConnectionsCountFinished(true),
    [FETCH_SUGGESTED_CONNECTIONS_COUNT_FAIL]: fetchSuggestedConnectionsCountFinished(false)
};

export const getConnectionRemoving = (state) => state.newsFeedConnections.connectionRemoving;
export const getConnectionRemoveSuccess = (state) => state.newsFeedConnections.connectionRemoveSuccess;
export const getConnectionRemoveFail = (state) => state.newsFeedConnections.connectionRemoveFail;
export const getConnectionMuting = (state) => state.newsFeedConnections.connectionMuting;
export const getConnectionMuteSuccess = (state) => state.newsFeedConnections.connectionMuteSuccess;
export const getConnectionMuteFail = (state) => state.newsFeedConnections.connectionMuteFail;
export const getConnectionUnmuting = (state) => state.newsFeedConnections.connectionUnmuting;
export const getConnectionUnmuteSuccess = (state) => state.newsFeedConnections.connectionUnmuteSuccess;
export const getConnectionUnmuteFail = (state) => state.newsFeedConnections.connectionUnmuteFail;
export const getMutedConnectionListFetching = (state) => state.newsFeedConnections.mutedConnectionListFetching;
export const getMutedConnectionListFetchFail = (state) => state.newsFeedConnections.mutedConnectionListFetchFail;
export const getMutedConnectionList = (state) => state.newsFeedConnections.mutedConnectionList;
export const getConnectionCount = (state) => state.newsFeedConnections.connectionCount;
export const getConnectionCountSuccess = (state) => state.newsFeedConnections.connectionCountSuccess;
export const getSuggestedConnectionList = (state) => state.newsFeedConnections.suggestedConnectionList;
export const getPagedSuggestedConnectionList = (state) => state.newsFeedConnections.pagedSuggestedConnectionList;
export const getPagedSuggestedConnectionListFetching = (state) =>
    state.newsFeedConnections.pagedSuggestedConnectionListFetching;
export const getPagedSuggestedConnectionListFetchSuccess = (state) =>
    state.newsFeedConnections.pagedSuggestedConnectionListFetchSuccess;
export const getSuggestedConnectionsCount = (state) => state.newsFeedConnections.suggestedConnectionsCount;
export const getSuggestedConnectionsCountFetchSuccess = (state) =>
    state.newsFeedConnections.suggestedConnectionsCountFetchSuccess;

export default function newsFeedConnections(state = INITIAL_STATE, action = {}) {
    const handler = handlers[action.type];

    if (!handler) return state;
    return handler(state, action);
}
